import { createAction } from 'redux-actions'

import { LOGIN, LOGOUT } from './constants'
import { loginApi, logoutApi } from './api'

export const loginAction = createAction(LOGIN, async (data) => await loginApi(data))
export const logoutAction = createAction(LOGOUT, async () => await logoutApi())
